import { render, staticRenderFns } from "./DatosContacto.vue?vue&type=template&id=45e7ed56&"
import script from "./DatosContacto.vue?vue&type=script&lang=js&"
export * from "./DatosContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports